<template>
    <v-card rounded="lg" flat color="grey-f7" style="overflow: unset;">
        <div class="pa-20 pa-md-30 pa-lg-40">
            <v-row align="center" class="row--large">
                <v-col cols="12" lg="6">
                    <v-row align="center">
                        <v-col cols="12" md="auto">
                            <p class="page-text font-weight-medium min-w-md-100px min-w-lg-auto">기간</p>
                        </v-col>
                        <v-col cols="12" md="">
                            <v-btn-toggle v-model="selected" mandatory group class="v-btn-toggle--outlined">
                                <v-btn small outlined  value="now">당일</v-btn>
                                <v-btn small outlined value="week">1주일</v-btn>
                                <v-btn small outlined value="month">1개월</v-btn>
                                <v-btn small outlined value="halfYear">6개월</v-btn>
                                <v-btn small outlined value="year">12개월</v-btn>
                            </v-btn-toggle>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" lg="6">
                    <v-row align="center">
                        <v-col cols="12" md="auto">
                            <p class="page-text font-weight-medium min-w-md-100px min-w-lg-auto">일자별 조회</p>
                        </v-col>
                        <v-col cols="12" md="">
                            <v-row class="row--x-small">
                                <v-col cols="12" md="">
                                    <v-row align="center" class="row--x-small">
                                        <v-col>
                                            <v-date-field v-model="filter.startsAt" v-bind="attrs_input" />
                                        </v-col>
                                        <v-col cols="auto">
                                            <p class="page-text page-text--sm">~</p>
                                        </v-col>
                                        <v-col cols="12" sm="">
                                            <v-date-field v-model="filter.endsAt" v-bind="attrs_input" />
                                        </v-col>
                                    </v-row>    
                                </v-col>
                                <v-col cols="12" md="auto">
                                    <v-btn color="primary" class="w-100" @click="()=>{$router.push({ query: filter })}">조회</v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>
    </v-card>
</template>

<script>
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";
import { attrs_input, } from "@/assets/variables";
import dayjs from 'dayjs';
export default {
    components: {
        VDateField,
    },
    data: () => ({
        attrs_input,
        selected: "",
        filter: {
            startsAt: null,
            endsAt: null,
        }
    }),
    watch:{
        selected(value){
            switch(value){
                case "now":
                    this.filter.startsAt= dayjs().format("YYYY-MM-DD");
                    this.filter.endsAt = dayjs().format("YYYY-MM-DD");
                    break;

                case "week":
                    this.filter.startsAt= dayjs().format("YYYY-MM-DD");
                    this.filter.endsAt = dayjs().add(1,'week').format("YYYY-MM-DD");
                    break;

                case "month":
                    this.filter.startsAt= dayjs().format("YYYY-MM-DD");
                    this.filter.endsAt = dayjs().add(1,'month').format("YYYY-MM-DD");
                    break;

                case "halfYear":
                    this.filter.startsAt= dayjs().format("YYYY-MM-DD");
                    this.filter.endsAt = dayjs().add(6,'month').format("YYYY-MM-DD");
                    break;

                case "year":
                    this.filter.startsAt= dayjs().format("YYYY-MM-DD");
                    this.filter.endsAt = dayjs().add(1,'year').format("YYYY-MM-DD");
                    break;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.v-btn-toggle{
    &--outlined{
        width: 100%;
        .v-btn{
            flex: 1 1 auto;
            border-color: #ddd;
            color: #666;
            background-color: #fff !important;
            border-radius: 6px !important;
            &::before{
                display: none;
            }
            &.v-btn--active{
                border-color: var(--v-primary-base);
                background-color: var(--v-primary-lighten5) !important;
                color: var(--v-primary-base);
            }
            &:not(.v-btn--fab,.v-btn--icon).v-size--small{
                height: 32px;
            }
        }
    }
}
.v-application--is-ltr .v-btn-toggle>.v-btn.v-btn:not(:first-child), .v-application--is-rtl .v-btn-toggle>.v-btn.v-btn:not(:last-child) {
    border-left-width: 1px;
}
@media (min-width:576px){
    .v-btn-toggle{
        &--outlined{
            .v-btn{
                flex: 1 1 0;
            }
        }
    }
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .v-btn-toggle{
        &--outlined{
            margin: -5px;
            .v-btn{
                margin: 5px;
            }
        }
    }
}
@media (min-width:1200px){
}
.row--x-small{
    margin: -4px;
}
.row--x-small>[class*=col] {
    padding: 4px;
}
</style>